export default [
  {
    path: "/labor/monthly-salary/list",
    name: "labor-monthly-salary",
    meta: { title: "月度工资记录" },
    component: () =>
      import(
        /* webpackChunkName: "labor-monthly-salary" */ "@/views/labor/monthly-salary/index.vue"
      ),
  },
];
